function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-bot-1{fill:#fff;}.cls-bot-2{fill:#4cb75c;}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "\n        kenai-bot-light\n    ");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "kenai-bot-light"
}, /*#__PURE__*/React.createElement("path", {
  d: "M150,187.1a57.89,57.89,0,0,1-39.6-15.2,7.26,7.26,0,0,1-.7-10.2h0a4.62,4.62,0,0,1,.7-.7,9.73,9.73,0,0,1,12.8,0,40,40,0,0,0,53.7,0,9.73,9.73,0,0,1,12.8,0,7.26,7.26,0,0,1,.7,10.2h0a4.62,4.62,0,0,1-.7.7A58.32,58.32,0,0,1,150,187.1Z",
  className: "cls-bot-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.31,133.5c-7.3,0-13.3-5.4-13.3-11.9s6-11.9,13.3-11.9,13.2,5.3,13.2,11.9S106.61,133.5,99.31,133.5Z",
  className: "cls-bot-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.71,133.5c-7.3,0-13.2-5.4-13.2-11.9s5.9-11.9,13.2-11.9S214,115,214,121.6,208,133.5,200.71,133.5Z",
  className: "cls-bot-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.11,42.6C230.41,15.4,191.31,0,150,0S69.61,15.4,40.91,42.6c-7.3,7.3-4.9,8.3,7.1,1.5h0c29.3-15.2,64.8-23.5,102-23.5s72.7,8.3,101.9,23.5h0C264,50.9,266.41,49.9,259.11,42.6Z",
  className: "cls-bot-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.61,121.2c-.1-.5-.3-1-.4-1.5a4.23,4.23,0,0,0-.4-1.2c-6.4-19.7-21.1-37.5-42.9-51.7C227.41,48.3,189.81,38,150,38S72.61,48.3,44.11,66.9c-21.8,14.2-36.4,32-42.9,51.7a5.64,5.64,0,0,1-.4,1.2,6.58,6.58,0,0,0-.4,1.5c-1.4,5.7.7,7.4,8,7.4h13.3c7.1,0,7.7-.9,12.6-10.3l1.3-2.5C53.31,86.5,99.71,66,150,66s96.7,20.6,114.3,49.8l1.3,2.5c4.9,9.4,5.5,10.3,12.6,10.3h13.4C298.91,128.6,301,126.9,299.61,121.2Z",
  className: "cls-bot-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.91,240.5c28.7,27.2,67.7,42.6,109.1,42.6s80.4-15.4,109.1-42.6c7.3-7.3,4.9-8.3-7.1-1.5h0c-29.2,15.2-64.8,23.5-101.9,23.5s-72.8-8.3-102-23.5h0C36,232.2,33.61,233.2,40.91,240.5Z",
  className: "cls-bot-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.41,161.9c.1.5.3,1,.4,1.5a4.23,4.23,0,0,0,.4,1.2c6.4,19.7,21.1,37.5,42.9,51.7,28.5,18.6,66.1,28.8,105.9,28.8s77.4-10.2,105.9-28.8c21.8-14.2,36.4-31.9,42.9-51.7a5.64,5.64,0,0,1,.4-1.2,6.58,6.58,0,0,0,.4-1.5c1.4-5.7-.7-7.4-8-7.4h-13.3c-7.1,0-7.7.9-12.6,10.3l-1.3,2.5c-17.6,29.2-64,49.8-114.3,49.8s-96.7-20.5-114.3-49.8l-1.3-2.5c-4.9-9.4-5.5-10.3-12.6-10.3H8.41C1.11,154.5-1,156.2.41,161.9Z",
  className: "cls-bot-2"
}));

var SvgIconKenaiBotLight = function SvgIconKenaiBotLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300.01 283.1",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconKenaiBotLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-kenai-bot-light.b0951b00.svg";
export { ForwardRef as ReactComponent };